import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useDateTimeFormatter } from '@atlassian/jira-issue-format-date';
import type { JiraDatePickerValue, FormatDateFn } from '../../common/types';
import messages from './messages';
import { EmptyValue } from './styled';

export type DateFieldReadViewProps = {
	value: JiraDatePickerValue;
	noValueText: string | null | undefined;
	onFormatDate?: FormatDateFn;
};

export const DateFieldReadView = ({ value, noValueText, onFormatDate }: DateFieldReadViewProps) => {
	const { formatMessage } = useIntl();
	const { formatDateOnly } = useDateTimeFormatter();

	if (value == null || value === '') {
		return <EmptyValue>{noValueText ?? formatMessage(messages.defaultNoValueText)}</EmptyValue>;
	}

	if (onFormatDate) {
		return <>{onFormatDate(value)}</>;
	}

	return <>{formatDateOnly(value)}</>;
};
